import { getPageDataKeyValue } from 'js/tools';
import * as Analytics from 'js/analytics';

const vehicleDataToProductDataMap = Object.entries({
    id: vehicleData => vehicleData?.id || 0,
    price: vehicleData => vehicleData?.prijs || 0,
    brand: vehicleData => vehicleData?.merk || '',
    category: vehicleData => vehicleData?.voertuigsoort || '',
    variant: vehicleData => {
        if (!vehicleData) {
            return '';
        }

        return [
            'aantalDeuren',
            'aantalZitplaatsen',
            'bouwjaar',
            'carrosserievorm',
            'energielabel',
            'kenteken',
            'kilometerstand',
            'kleur',
            'typeFinanciering'
        ]
            .filter(prop => vehicleData[prop])
            .map(prop => `${prop}: ${vehicleData[prop]}`)
            .join(' | ');
    },
    dimension6: vehicleData => vehicleData?.model || '',
    dimension7: vehicleData => vehicleData?.brandstof || '',
    dimension8: vehicleData => vehicleData?.aanbieder?.id || 0,
    dimension9: vehicleData => vehicleData?.aanbieder?.plaats || ''
});

const vehicleAttrToProductDataMap = Object.entries({
    name: vehicleAttr => vehicleAttr.title || '',
    id: vehicleAttr => vehicleAttr.id || 0,
    price: vehicleAttr => vehicleAttr.price || 0,
    brand: vehicleAttr => vehicleAttr.brand || '',
    category: vehicleAttr => vehicleAttr.vehicleType || '',
    variant: vehicleAttr => {
        if (!vehicleAttr) {
            return '';
        }

        return [
            'mileage',
            'year',
            'engineCapacity',
            'frameType',
            'gearCountNumeric',
            'frameHeight',
            'bodyType',
            'wheelSize'
        ]
            .filter(prop => vehicleAttr[prop])
            .map(prop => `${prop}: ${vehicleAttr[prop]}`)
            .join(' | ');
    },
    dimension6: vehicleAttr => vehicleAttr.model || '',
    dimension7: vehicleAttr => (vehicleAttr.fuelTypes && vehicleAttr.fuelTypes[0]) || '',
    dimension8: () => null,
    dimension9: vehicleAttr => vehicleAttr.carCompanyCity || ''
});

const formIdToFormDescriptionValueMap = new Map(
    Object.entries({
        'car-exchange': 'Inruilwaarde weten',
        'car-contact': 'Stel je vraag',
        'car-test-drive': 'Proefrit',
        'reservation-request': ''
    })
);

function mapFormIdToFormDescription(formId) {
    return formIdToFormDescriptionValueMap.get(formId);
}

function mapVehicleDataToProductData(vehicleData) {
    return mappingReducer(vehicleData, vehicleDataToProductDataMap);
}

function mapVehicleAttrToProductData(vehicleAttr) {
    return mappingReducer(vehicleAttr, vehicleAttrToProductDataMap);
}

function mappingReducer(data, mapping) {
    return mapping.reduce((mappedData, [key, mapper]) => {
        mappedData[key] = mapper(data);

        return mappedData;
    }, {});
}

export function registerEcommerceEvent(event, ecommerce) {
    Analytics.trackData({
        event,
        ecommerce
    });
}

export function getFormDescriptionFromFormId(formId) {
    return mapFormIdToFormDescription(formId);
}

export function getMobilityTypeFromVehicleData() {
    return getPageDataKeyValue('vehicleDetails')?.typeMobiliteit;
}

export function getMobilityTypeFromVehicleNode(vehicleNode) {
    const vehicleAttr = JSON.parse(vehicleNode?.getAttribute('data-vehicle'));

    return vehicleAttr.mobilityType;
}

export function getProductDataFromVehicleData() {
    return {
        name: document.querySelector('.headline-big')?.innerHTML,
        ...mapVehicleDataToProductData(getPageDataKeyValue('vehicleDetails'))
    };
}

export function getProductDataFromVehicleNode(vehicleNode) {
    const vehicleAttr = JSON.parse(vehicleNode.getAttribute('data-vehicle'));

    return mapVehicleAttrToProductData(vehicleAttr);
}
